export default "__VITE_ASSET__BM6ZqgO6__"